import './DownloadPrescriptionHistory.css';

import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';

import { getTranslation, keys } from '../../../../Resources/Translations';

interface DownloadPrescriptionHistoryProps {
    onClick: () => void;
}

export const DownloadPrescriptionHistory = (props: DownloadPrescriptionHistoryProps) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const buttonWrapperRef = useRef<HTMLDivElement>(null);
    const [isSticky, setIsSticky] = useState<boolean>(true);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsSticky(!entry.isIntersecting);
            },
            {
                root: null,
                threshold: 1
            }
        );

        if (containerRef.current) {
            observer.observe(containerRef.current);
        }

        return () => {
            if (containerRef.current) {
                observer.unobserve(containerRef.current);
            }
        };
    }, []);

    return (
        <div className="DownloadPrescriptionHistory" ref={containerRef}>
            <div
                className={classNames('DownloadPrescriptionHistory__ButtonWrapper', isSticky && 'DownloadPrescriptionHistory__ButtonWrapper--Sticky')}
                ref={buttonWrapperRef}
            >
                <button className="Button Button--Primary Button--Medium DownloadPrescriptionHistory__Button" onClick={props.onClick}>
                    {getTranslation(keys['prescriptionHistory.downloadPrescriptionHistory'])}
                </button>
            </div>
        </div>
    );
};
